"use client";

import { usePathname } from "next/navigation";

/**
 * SP のエリア名ヘッダー (AreaSpHeader) はエリアトップ専用。
 * 各ページが最上部に固有の見出しを持つ配下は、 エリア名と二重に出ないよう抑止する:
 * - 拠点・部屋タイプ詳細 (/sites/ 配下): 拠点名 / 部屋名
 * - おすすめスポット (/spots): "おすすめスポット ○○エリア"
 */
export function AreaTopHeaderGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname?.includes("/sites/")) return null;
  if (pathname?.endsWith("/spots")) return null;
  return <>{children}</>;
}
